import {
    useCreateSurchargeGroupMutation,
    useLazyOneSurchargeGroupQuery,
    useUpdateSurchargeGroupMutation
} from "../../../../api/surcharge.slice.ts";
import {useEffect, useState} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {SERVER_VALIDATION_ERRORS} from "../../../../components/Form/CONSTANTS.ts";
import {DataLoadingError} from "../../../../components/DataLoadingError.tsx";
import {ConnectedInput} from "../../../../components/Form/ConnectedInput.tsx";
import {ConnectedMultiSelect} from "../../../../components/Form/ConnectedMultiSelect.tsx";
import {Button} from "../../../../components/Button.tsx";
import {useGetActivityTypesQuery} from "../../../../api/activity.slice.ts";

type Inputs = {
    name: string,
    applicableActivityTypes: Array<string>
}

type SurchargeGroupFormProps = {
    id?: string
    onCancel: () => void
}

export const SurchargeGroupForm = ({id, onCancel}: SurchargeGroupFormProps) => {

    const {data: activityTypes} = useGetActivityTypesQuery()
    const [trigger, {data, isLoading, error}] = useLazyOneSurchargeGroupQuery()
    const [isEditMode, setEditMode] = useState(false)
    const [isSubmitting, setSubmitting] = useState(false)

    const [createGroup] = useCreateSurchargeGroupMutation()
    const [updateGroup] = useUpdateSurchargeGroupMutation()

    const methods = useForm<Inputs>({
        values: data ? {...data} : undefined,
    })

    const onSubmit: SubmitHandler<Inputs> = (data) => {

        const action = isEditMode ? updateGroup : createGroup

        setSubmitting(true)
        action({...data, id: id!})
            .unwrap()
            .then(result => console.log("a", result))
            .catch(err => {
                if (err.status === 400) {
                    for (const [key, value] of Object.entries(err?.data.violations)) {
                        //Can't really think of a good way to type this. The api response is just "Trust me bro"
                        methods.setError(key as unknown as any, {
                            types: {
                                [SERVER_VALIDATION_ERRORS]: value as unknown as Array<string>
                            }
                        })
                    }
                }
            })
            .finally(() => setSubmitting(false))
    }

    useEffect(() => {
        if (id) {
            setEditMode(true)
            trigger(id)
        }
    }, [id])

    const handleSubmit = methods.handleSubmit

    console.log(activityTypes)

    return (
        <DataLoadingError isLoading={isLoading} error={error}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ConnectedInput name="name" label="Name" type={"text"}/>
                    <ConnectedMultiSelect name={"applicableActivityTypes"} label={"Applicable Activity"} options={activityTypes?.map(a => ({label:a, key:a,id:a })) || []}/>
                    <div className="btn-toolbar" style={{display: "flex", flexDirection: "row-reverse"}}>

                        <Button isLoading={isSubmitting} type={"submit"}>{isEditMode ? "Update" : "Create"}</Button>
                        <Button disabled={isSubmitting} onClick={(event) => {
                            event.preventDefault()
                            onCancel()
                        }}>Cancel</Button>
                    </div>
                </form>
            </FormProvider>
        </DataLoadingError>
    )
}